import React from "react";
import { Redirect } from "react-router-dom";
import { log } from "./utils";
import SignUpScreen from "./SignUpScreen";
import MainPage from "./MainPage";
import data from "./postMessages.json";
import firebase from "./firebase/firebase";
import { signInWithEmail, getUser } from "./dao/auth";
import ForgetPassword from "./ForgetPassword";

class SignInScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      pwd: "",
      login: false,
      loading: false,
      loginErr: false,
      showCreateAccount: false,
      forgotPassword: false,
    };

    this.onCreateAccount = this.onCreateAccount.bind(this);
    this.onChange = this.onChange.bind(this);
    this.Login = this.Login.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
  }

  onCreateAccount(event) {
    event.preventDefault();
    this.props.appProps.handleSignInState(false);
    this.setState({
      showCreateAccount: true,
    });
  }

  forgotPassword(event) {
    this.setState({
      forgotPassword: true,
    });
    this.props.appProps.handleForgotPassword(true);
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      loginErr: false,
    });
  }

  Login(event) {
    const { email, pwd } = this.state;

    this.setState({
      loading: true,
    });

    signInWithEmail(email, pwd, (resp) => {
      if (resp.login) {
        getUser(email, (resp) => {
          console.log("user login :", resp.userInfo.FullName);
          const fullname = resp.userInfo.FullName;
          this.props.appProps.handleUpdateState(fullname, email, true);
          this.setState({
            showCreateAccount: false,
            login: true,
            loading: false,
          });
        });
      } else {
        console.log("error userlogin ", resp.error.errorMsg);
        this.setState({
          loginErr: true,
          loading: false,
        });
      }
    });
  }

  render() {
    if (this.props.resetChild) {
      this.props.resetChild();
    }

    if (this.state.showCreateAccount) {
      return <SignUpScreen appProps2={this.props.appProps} />;
    }

    if (this.state.login) {
      return (
        <MainPage username={this.state.email} appProps2={this.props.appProps} />
      );
    }

    if (this.state.forgotPassword) {
      return <ForgetPassword appProps2={this.props.appProps} resetScr={this} />;
    }

    return (
      <div>
        <div
          className="w-100 container p-0 my-5 border rounded glassmorph"
          style={{ maxWidth: "400px" }}
        >
          <div className="container p-2 text-center rounded-top gradientTop">
            <h3>Login</h3>
            <hr className="w-75"></hr>
          </div>
          {/** Sign in form */}
          <div className="container p-3">
            <div className="form-group">
              <label for="usr">Email</label>
              <input
                type="text"
                className="form-control shadow-none"
                name="email"
                value={this.state.email}
                onChange={this.onChange}
              />
            </div>

            <div className="form-group">
              <label for="pwd">Password</label>
              <input
                type="password"
                className="form-control shadow-none"
                name="pwd"
                value={this.state.pwd}
                onChange={this.onChange}
              />
            </div>

            <div className="form-group form-check">
              <label className="form-check-label">
                <input
                  className="form-check-input shadow-none"
                  type="checkbox"
                />
                Remember me
              </label>{" "}
              {/** had onClick to store user input in system(firebase) */}
            </div>
            {!this.state.loading ? (
              <button
                type="button"
                className="btn btn-secondary btn-block"
                value="login"
                onClick={this.Login}
              >
                Login
              </button>
            ) : (
              <button
                disabled
                type="button"
                className="btn btn-secondary btn-block"
                value="login"
                onClick={this.Login}
              >
                <span class="spinner-border spinner-border-sm"></span>
                &nbsp;Login...
              </button>
            )}

            <div class="row">
              <div className="col my-3">
                <p className="text-left">
                  <p className="pointer" onClick={this.forgotPassword}>
                    Forget Password?
                  </p>
                </p>
              </div>
              <div className="col my-3">
                <p className="text-right">
                  <p className="pointer" onClick={this.onCreateAccount}>
                    Create an Account
                  </p>
                </p>
              </div>
              {/** Error message */}
            </div>
            {this.state.loginErr ? (
              <div class="alert alert-danger text-center">
                <strong>Invalid!</strong> login credentials
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SignInScreen;
